export const AIRA_KEY_HEAD = 'aira' as const

export const airaKeys = {
  vocab: () => [AIRA_KEY_HEAD, 'vocab'] as const,
}
